import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';



const FAQSection = ({ faqData }) => {
    const [openId, setOpenId] = useState(1);

    const toggleAccordion = (id) => {
        setOpenId((prev) => (prev === id ? null : id));
    };

    return (
        <section className="w-full bg-[#FDFDFD] pb-16 lg:pb-24 relative text-left">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                <div className="flex flex-col lg:flex-row gap-10 lg:gap-20 items-start">

                    <div className="w-full lg:w-[38%] lg:sticky lg:top-24">
                        <h2 className="text-[#01386A] font-sora text-[22px] lg:text-[32px] font-[600] leading-tight">
                            Frequently Asked <span className="text-[#EA6B24]">Questions</span>
                        </h2>
                        <p className="text-[#49577A] font-graphik text-[14px] lg:text-[16px] font-[500] mt-3 leading-relaxed">
                            Find quick answers to common queries regarding our modern service experience platforms, workflows, and implementation roadmaps.
                        </p>
                    </div>

                    <div className="w-full lg:w-[62%] flex flex-col gap-4 sm:gap-5">
                        {faqData.map((item, index) => {
                            const isOpen = openId === item.id;
                            return (
                                <div
                                    key={item.id}
                                    className={`bg-white border transition-all duration-300 overflow-hidden ${isOpen
                                            ? 'border-[#E2E8F0] border-l-[4px] border-l-[#EA6B24] -translate-y-0.5'
                                            : 'border-[#E2E8F0] border-l-[4px] border-l-[#01386A] hover:border-l-[#EA6B24]'
                                        }`}
                                >
                                    <button
                                        onClick={() => toggleAccordion(item.id)}
                                        className="w-full p-6 sm:p-7 flex items-center justify-between gap-6 text-left cursor-pointer outline-none group"
                                        aria-expanded={isOpen}
                                    >
                                        <div className="flex items-center gap-4">
                                            <span className={`text-[12px] font-sora font-[700] transition-colors duration-300 ${isOpen ? 'text-[#EA6B24]' : 'text-[#49577A]/60 group-hover:text-[#EA6B24]'
                                                }`}>
                                                0{index + 1}
                                            </span>
                                            <span className={`font-sora font-[600] text-[15px] sm:text-[18px] tracking-tight transition-colors duration-200 ${isOpen ? 'text-[#01386A]' : 'text-[#01386A] group-hover:text-[#EA6B24]'
                                                }`}>
                                                {item.question}
                                            </span>
                                        </div>

                                        <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-colors duration-300 ${isOpen ? 'bg-[#EA6B24]/10 text-[#EA6B24]' : 'bg-[#F0F0F0] text-[#01386A] group-hover:text-[#EA6B24]'
                                            }`}>
                                            <ChevronDown
                                                size={18}
                                                className={`transition-transform duration-300 ease-in-out ${isOpen ? 'rotate-180' : ''
                                                    }`}
                                            />
                                        </div>
                                    </button>

                                    <div
                                        className={`grid transition-all duration-300 ease-in-out px-6 sm:px-7 ${isOpen ? 'grid-rows-[1fr] opacity-100 pb-6 sm:pb-7' : 'grid-rows-[0fr] opacity-0 pb-0'
                                            }`}
                                    >
                                        <div className="overflow-hidden">
                                            <p className="font-graphik font-[400] text-[14px] sm:text-[15px] leading-[1.65] text-[#555555] border-t border-[#E2E8F0] pt-4">
                                                {item.answer}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                </div>
            </div>
        </section>
    );
};

export default FAQSection;